import { useContext } from 'react';
import { IRBACTabs, RBACPermissionTypes } from '../types/IRBAC';
import { AllowedFields } from 'App';
import { ApplicationTabsEnum } from 'components/Enums';

export const useRBAC = () => {
  const RBACPermissions = useContext(AllowedFields); // need to update this with actual data from BE
  const areAllPermissionsAvailable = () => {
    return RBACPermissions === '*';
  };
  const lookupPermissions = (
    hierarchy: ApplicationTabsEnum[],
    permissions?: RBACPermissionTypes
  ): RBACPermissionTypes | null | boolean => {
    let currentObj: string | IRBACTabs | undefined = RBACPermissions;
    if (typeof currentObj === 'string') {
      return areAllPermissionsAvailable();
    } else {
      for (let i = 0; i < hierarchy.length; i++) {
        const tab = hierarchy[i];
        if (
          currentObj &&
          Object.prototype.hasOwnProperty.call(currentObj, tab as string)
        ) {
          currentObj =
            i === hierarchy.length - 1
              ? currentObj[tab]
              : currentObj[tab]?.subMenu;
        } else {
          return null;
        }
      }

      return (
        (permissions
          ? currentObj?.permissions?.includes(permissions)
          : currentObj?.permissions) || null
      );
    }
  };

  return { lookupPermissions, isAdmin: areAllPermissionsAvailable };
};
